import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import {IToastViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';

export default class ToastViewModel extends ControlViewModel {
    public message: KnockoutObservable<string>;
    public autoDismissDelay: number;
    public transitionDuration: number;

    private onClosedCallbacks: ((vm: ToastViewModel) => void)[] = [];
    
    constructor(params: IToastViewModelConstructorParameter) {
        super(params);

        this.message = this.observableOrDefault(params.message, '');
        this.autoDismissDelay = this.paramOrDefault(params.autoDismissDelay, 5000);
        this.transitionDuration = this.paramOrDefault(params.transitionDuration, 500);
    }

    public addOnClosedCallback(callback: (vm: ToastViewModel) => void): void {
        this.onClosedCallbacks.push(callback);
    }

    public close(): void {
        for (let callback of this.onClosedCallbacks) {
            callback(this);
        }
    }
}

ComponentManager.setViewModel('ToastViewModel', ToastViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');